import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  failurelistDailygoals,
  successlistDailygoals,
} from "./ListdailygoalsSlice";
import {
  failurelistDashboardprogress,
  successlistDashboardprogress,
} from "./ListDashboardprogressSlice";
import {
  failurelistPerformance,
  successlistPerformance,
} from "./ListPerformanceSlice";
import {
  failurelistQuestionBank,
  successlistQuestionBank,
} from "./ListQuestionBankSlice";
import {
  ICreategoals,
  IPerformance,
  IPrefmanceTrend,
} from "../../../Pages/DashboardUserStudent/IDashboardUserStudent";
import { IAPIResponse } from "../../interfaces/IAPIResponse";
import {
  failurelistPrefmanceTrend,
  successlistPrefmanceTrend,
} from "./ListPrefmanceTrendSlice";
import {
  failurelistRecentActivity,
  successlistRecentActivity,
} from "./ListRecentActivitySlice";
import {
  failureaddCreategoals,
  successaddCreategoals,
} from "./AddCreategoalsSlice";

// Dailygoals list
const ListDailygoalsApi = () => {
  return api.get("/api/dashboard/dailygoals");
};

export function* ListDailygoalsCall() {
  try {
    const response: AxiosResponse = yield call(ListDailygoalsApi);
    yield put(successlistDailygoals(response.data));
  } catch (error) {
    yield put(failurelistDailygoals(error));
  }
}

// dashboardprogress
const ListDashboardprogressApi = () => {
  return api.get("/api/dashboardprogress");
};

export function* ListDashboardprogressCall() {
  try {
    const response: AxiosResponse = yield call(ListDashboardprogressApi);
    yield put(successlistDashboardprogress(response.data));
  } catch (error) {
    yield put(failurelistDashboardprogress(error));
  }
}
//  Performance
const ListPerformanceApi = (action: PayloadAction<IPerformance>) => {
  return api.get("/api/dashboard/performance", {
    params: action.payload,
  });
};

export function* ListPerformanceCall(action: PayloadAction<IPerformance>) {
  try {
    const response: AxiosResponse = yield call(ListPerformanceApi, action);
    yield put(successlistPerformance(response.data));
  } catch (error) {
    yield put(failurelistPerformance(error));
  }
}

// Question Bank
const ListQuestionBankApi = () => {
  return api.get("/api/dashboard/questionBank-status");
};

export function* ListQuestionBankCall() {
  try {
    const response: AxiosResponse = yield call(ListQuestionBankApi);
    yield put(successlistQuestionBank(response.data));
  } catch (error) {
    yield put(failurelistQuestionBank(error));
  }
}

// RecentActivity
const ListRecentActivityApi = () => {
  return api.get("/api/dashboard/recentActivity");
};

export function* ListRecentActivityCall() {
  try {
    const response: AxiosResponse = yield call(ListRecentActivityApi);
    yield put(successlistRecentActivity(response.data));
  } catch (error) {
    yield put(failurelistRecentActivity(error));
  }
}

// PrefmanceTrend
const ListPrefmanceTrendApi = (action: PayloadAction<IPrefmanceTrend>) => {
  return api.get("/api/dashboard/prefmanceTrend", {
    params: action.payload,
  });
};

export function* ListPrefmanceTrendCall(
  action: PayloadAction<IPrefmanceTrend>
) {
  try {
    const response: AxiosResponse<IAPIResponse<IPrefmanceTrend>> = yield call(
      ListPrefmanceTrendApi,
      action
    );
    yield put(successlistPrefmanceTrend(response.data));
  } catch (error) {
    yield put(failurelistPrefmanceTrend(error));
  }
}

// Create Goals
// add
const AddCreategoalsApi = (action: PayloadAction<ICreategoals>) => {
  return api.post("/api/dashboard/creategoals", action.payload);
};

export function* AddCreategoalsCall(action: PayloadAction<ICreategoals>) {
  try {
    const response: AxiosResponse = yield call(AddCreategoalsApi, action);
    yield put(successaddCreategoals(response.data));
  } catch (error) {
    yield put(failureaddCreategoals(error));
  }
}
